const faqs = [
  {
    q: '97影院的电视剧都是免费观看的吗？',
    a: '是的，97影院所有电视剧全集均支持免费在线观看，无需付费或会员订阅。我们持续更新最新国产剧、韩剧、美剧资源，为用户提供永久免费的追剧体验。',
  },
  {
    q: '支持哪些设备和浏览器？',
    a: '97影院全面适配电脑、平板和手机端，支持Chrome、Safari、Edge等主流浏览器。无需下载任何插件或APP，打开网页即可流畅观看高清电视剧。',
  },
  {
    q: '电视剧画质怎么样？会卡顿吗？',
    a: '全站剧集均提供高清蓝光画质（1080P起步，部分支持4K），并部署全球CDN加速节点，确保播放流畅不卡顿。网络良好的情况下，可实现秒开秒播。',
  },
  {
    q: '更新频率如何？能不能及时看到最新剧集？',
    a: '我们坚持与电视台和主流平台同步更新，热门剧集通常在上线后2小时内即可在97影院观看。每日更新动态可在"更新速递"板块实时查看。',
  },
  {
    q: '剧集资源覆盖哪些类型？',
    a: '97影院覆盖国产剧、韩剧、美剧三大核心品类，同时涵盖日剧、泰剧、台剧等多元内容。类型上包括古装、都市、悬疑、甜宠、科幻、仙侠等全品类，满足不同观众的追剧口味。',
  },
  {
    q: '需要注册账号才能观看吗？',
    a: '不需要。97影院无需注册即可直接观看所有电视剧全集。如果你希望跨设备同步观看进度和收藏，可以选择使用收藏功能（本地存储），方便快捷。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于97影院的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 font-heading text-lg flex-shrink-0">Q{i + 1}</span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}